import {getBrowserSearchCompatibleEnv} from '@/shared/lib/env/getBrowserEnv';
import {logger} from '@/shared/services/logger';

export const getDefaultAuthQueryParams = async () => {
  try {
    const browserEnv = await getBrowserSearchCompatibleEnv();
    return new URLSearchParams({
      ...browserEnv,
      rate_limit: '1',
    });
  } catch (error) {
    logger.critical('Error getting browser environment:', {
      error: String(error),
    });
    return new URLSearchParams();
  }
};
